import { centsToDollarsString } from 'lib/helpers';
import { Alert } from 'lib/components/Alert';
import LoadingState from 'components/LoadingState';
import PricingComparison from './PricingComparison';
import OrderSummaryRow from '../OrderSummaryRow';

type PricingProps = {
  showComparison: boolean;
  oldTotalInCents: number | null;
  totalInCents: number | undefined;
  isPartialRefund: boolean;
  invoiceLoading: boolean;
  orderIsIOC?: boolean;
};

function Pricing({
  showComparison,
  oldTotalInCents,
  totalInCents,
  isPartialRefund,
  invoiceLoading,
  orderIsIOC
}: PricingProps) {
  if (
    totalInCents === undefined ||
    (showComparison && oldTotalInCents === null)
  ) {
    return <Alert id="pricing-alert" title="Missing total" />;
  }

  if (showComparison && oldTotalInCents !== null) {
    return (
      <PricingComparison
        oldTotalInCents={oldTotalInCents}
        totalInCents={totalInCents}
        invoiceLoading={invoiceLoading}
        isPartialRefund={isPartialRefund}
      />
    );
  }

  const label = orderIsIOC
    ? 'Total Price (Amount to be invoiced outside of Column)'
    : 'Total Price';
  return (
    <OrderSummaryRow
      label={label}
      data={
        invoiceLoading ? (
          <LoadingState
            isFullScreen={false}
            timeout={300}
            context={{
              location: '/ads/place/order-summary'
            }}
          />
        ) : (
          `$${centsToDollarsString(totalInCents)}`
        )
      }
    />
  );
}

export default Pricing;
